import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Header } from 'semantic-ui-react';
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface ConnectedProps {
    endDate?: string;
}

type Props = ConnectedProps;

export class SharedEventEndDateHeader extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { endDate } = this.props;
        if (!endDate) return null;
        return (
            <Header sub className="shared-event-sub-header">
                End Date
            </Header>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    endDate: makeSelectSharedEventValue('endDate')
});

export default connect(mapStateToProps)(SharedEventEndDateHeader);
